import Page from 'modules/DnaHowItWorks'

export default Page

